<template>
  <div class="relative">
    <slot />
    <u-textarea
      v-if="multiline"
      autoresize
      :rows="1"
      :maxrows="10"
      :maxlength="maxlength"
      v-model="localModel"
      @update:modelValue="onLive"
      @blur="commit"
      @keyup.esc="onEscKey"
      @keydown.esc.stop
      color="white"
      variant="outline"
      :placeholder="placeholder"
      :disabled="disabled"
      :ui="ui"
    />
    <u-input
      v-else
      :maxlength="maxlength"
      v-model="localModel"
      @update:modelValue="onLive"
      @blur="commit"
      @keyup.esc="onEscKey"
      @keydown.esc.stop
      color="white"
      variant="outline"
      :placeholder="placeholder"
      :disabled="disabled"
      :ui="ui"
    />
  </div>
</template>

<script setup>
const props = defineProps({
  multiline: Boolean,
  aiEnhancePadding: Boolean,
  placeholder: String,
  disabled: Boolean,
  maxlength: Number
})

const model = defineModel(); // committed value (saves on blur)
const live = defineModel('live', { default: '' }) // live typing value

const emit = defineEmits(['commit'])

const localModel = ref(model.value ?? '')

watch(model, (v) => {
  const val = v ?? ''
  localModel.value = val
  live.value = val
});

const ui = {
  base: 'disabled:cursor-default scrollbar-light',
  placeholder: 'dark:placeholder-gray-700',
  color: {
    white: {
      outline: `ring-0 focus:ring-0 border-b border-white/5 focus:border-white/50 transition-colors px-0 py-1 ${props.aiEnhancePadding ? ' pb-7' : ''}`
    }
  }
}

function onLive(val) {
  live.value = val
  localModel.value = val
}

function commit() {
  model.value = localModel.value
  emit('commit', model.value)
}

function onEscKey(e) {
  e.stopPropagation()
  e.srcElement && e.srcElement.blur && e.srcElement.blur()
}
</script>
